import { Internal } from '@gleamer/types';
import { milliseconds } from 'date-fns';

export const EXPIRED_TIME_KEY = '_expiredTime';

class IdleTimer {
  private static readonly EVENTS: Internal.DocumentEventType[] = [
    'focus',
    'keydown',
    'keyup',
    'mousemove',
    'mousedown',
    'mouseup',
    'wheel',
    'scroll',
  ];
  /**
   * Activity pushes the expiry back at once, then at most this often: a trailing debounce (write once the events
   * stop) never wrote while the mouse kept moving — which the logout warning asks for — nor, on a page opened
   * with the mouse moving, at all.
   */
  private static readonly WRITE_EVERY_MS = 1000;
  timeout: Duration;
  onTimeout: () => void;
  eventHandler: () => void;
  interval: ReturnType<typeof setInterval>;
  lastWrite = 0;

  constructor({
    timeout,
    onTimeout,
    onExpired,
  }: {
    timeout: Duration;
    onTimeout: () => void;
    onExpired: () => void;
  }) {
    this.timeout = timeout;
    this.onTimeout = onTimeout;

    const expiredTime = parseInt(
      localStorage.getItem(EXPIRED_TIME_KEY) || '0',
      10
    );
    if (expiredTime > 0 && expiredTime < Date.now()) {
      localStorage.removeItem(EXPIRED_TIME_KEY);
      onExpired();
      return;
    }

    this.eventHandler = this.updateExpiredTime.bind(this);
    this.tracker();
    this.startInterval();
  }

  startInterval() {
    this.updateExpiredTime();

    this.interval = setInterval(() => {
      const expiredTime = parseInt(
        localStorage.getItem(EXPIRED_TIME_KEY) || '0',
        10
      );
      if (expiredTime < Date.now()) {
        if (this.onTimeout) {
          this.onTimeout();
          this.cleanUp();
        }
      }
    }, 1000);
  }

  updateExpiredTime() {
    const now = Date.now();
    if (now - this.lastWrite < IdleTimer.WRITE_EVERY_MS) {
      return;
    }
    this.lastWrite = now;
    localStorage.setItem(
      EXPIRED_TIME_KEY,
      `${now + milliseconds(this.timeout)}`
    );
  }

  tracker() {
    IdleTimer.EVENTS.forEach(event => {
      window.addEventListener(event, this.eventHandler);
    });
  }

  cleanUp() {
    clearInterval(this.interval);
    IdleTimer.EVENTS.forEach(event => {
      window.removeEventListener(event, this.eventHandler);
    });
  }
}
export default IdleTimer;
